import { render } from "./OrganisationList.vue?vue&type=template&id=1761eb34&scoped=true"
import script from "./OrganisationList.vue?vue&type=script&lang=js"
export * from "./OrganisationList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1761eb34"

export default script